import * as React from "react";
import {useDebounce} from 'react-use';
import {DEBOUNCE_TIME} from "../utils/constants";

export default function useSearchDebounce(initialState: any = '') {
    const [searchInputValue, setSearchInputValue] = React.useState(initialState)
    const [searchInputTerm, setSearchInputTerm] = React.useState(initialState)
    useDebounce(() => {
        setSearchInputTerm(searchInputValue)
    }, DEBOUNCE_TIME, [searchInputValue])
    return [searchInputValue, setSearchInputValue, searchInputTerm]
}
